import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { AccessIcon } from "@/components/AccessIcon";

export function LegalLayout({ title, updated, children }: { title: string; updated?: string; children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-[var(--color-soft)]">
      {/* Header */}
      <header className="border-b border-border bg-white">
        <div className="max-w-2xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/access/dashboard" className="flex items-center gap-2.5">
            <AccessIcon size={24} className="text-[var(--color-gold)]" />
            <div className="font-display tracking-wider text-sm">
              LAGAMOBILEN <span className="text-[var(--color-gold)] font-semibold">ACCESS</span>
            </div>
          </Link>
          <Link
            to="/access/dashboard"
            className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1.5 transition-colors"
          >
            <ArrowLeft size={12} /> Tillbaka
          </Link>
        </div>
      </header>

      {/* Main content */}
      <main className="max-w-2xl mx-auto px-6 py-12 lg:py-16">
        {/* Title block */}
        <div className="mb-10">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-display font-bold text-foreground leading-tight tracking-tight">
            {title}
          </h1>
          {updated && (
            <p className="mt-2 text-sm text-muted-foreground">{updated}</p>
          )}
          <div className="mt-4 h-px w-16 bg-[var(--color-gold)]" />
        </div>

        {/* Article body */}
        <article className="legal-article">
          {children}
        </article>

        {/* Footer */}
        <footer className="mt-20 pt-8 border-t border-border">
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-muted-foreground">
            <Link to="/access/villkor" className="hover:text-foreground transition-colors">
              Medlemsvillkor
            </Link>
            <Link to="/access/integritetspolicy" className="hover:text-foreground transition-colors">
              Integritetspolicy
            </Link>
            <Link to="/access/angerratt" className="hover:text-foreground transition-colors">
              Ångerrätt
            </Link>
            <span className="ml-auto text-muted-foreground/70">
              © {new Date().getFullYear()} ResQ My Device AB · Org.nr 559149-4496
            </span>
          </div>
        </footer>
      </main>
    </div>
  );
}
